var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0721 1.66602C5.4771 1.66602 1.73877 5.40435 1.73877 9.99935C1.73877 14.5943 5.4771 18.3327 10.0721 18.3327C14.6671 18.3327 18.4054 14.5943 18.4054 9.99935C18.4054 5.40435 14.6671 1.66602 10.0721 1.66602ZM8.40627 13.6768L5.3121 10.5893L6.48877 9.40935L8.4046 11.3218L12.8163 6.91018L13.9946 8.08852L8.40627 13.6768Z",
    fill: "#54BA4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.36a24a2b5932f9b1d237a4ae10cb2074.svg";
export { ForwardRef as ReactComponent };